<!--
	Kontrola stavu prihlásenia pre obrazkovky, ktoré nemjú byť prístupné neprihláseným užívateľom
-->
<script lang="ts">
	import type { DialerAgentConfiguration } from "../libs/app/configuration";
	import type { Writable } from "svelte/store";

	import { api, dialerAgent } from "../bootstrap";
	import { connectSipClients } from "../libs/sip/connect-sip-clients";
	import { onMount } from "svelte";
	import { useNavigate, useLocation, useFocus } from "svelte-navigator";

	let isChecking = true;

	const navigate = useNavigate();
	const location = useLocation();
	const registerFocus = useFocus();
	const configuration: Writable<DialerAgentConfiguration> = dialerAgent.configuration;

	$: if (!$configuration && !isChecking) {
		navigateToLogin();
	}

	/**
	 * Kontrola či je prihlásenie ešte aktívne
	 */
	async function checkLoginStatus(): Promise<boolean | null> {
		const conf = await api.checkLoginStatus();
		if (conf === false || conf === null) {
			throw new Error("");
		}
		configuration.set(conf);
		connectSipClients(conf);
		return true;
	}

	/**
	 * Presmerovanie na prihlasovaciu obrazovku
	 */
	function navigateToLogin() {
		navigate("/", {
			state: { from: $location.pathname },
			replace: true,
		});
	}

	/**
	 * Spustenie kontroly
	 */
	onMount(async () => {
		try {
			await checkLoginStatus();
		} catch {
			navigateToLogin();
		} finally {
			isChecking = false;
		}
	});
</script>

{#if $configuration && !isChecking}
	<slot {registerFocus} />
{/if}

{#if isChecking}
	<p>Kontrolujem stav prihlásenia ...</p>
{/if}
